import { render, staticRenderFns } from "./ScreenData.vue?vue&type=template&id=412bff6c&scoped=true&"
import script from "./ScreenData.vue?vue&type=script&lang=js&"
export * from "./ScreenData.vue?vue&type=script&lang=js&"
import style0 from "./ScreenData.vue?vue&type=style&index=0&id=412bff6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412bff6c",
  null
  
)

export default component.exports